import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { FolderOpen, Users, UserPlus, SlidersHorizontal, Sparkles } from "lucide-react";

const TIPS = [
  {
    icon: FolderOpen,
    title: "One hub for you and your clients",
    body: "Each project file is your shared administrative hub. You and your client both work from the same place — keeping budgets, approvals, mood boards, notes and timelines up to date in real time.",
  },
  {
    icon: Users,
    title: "Adding team members",
    body: "Invite teammates from Settings → Team members. Each receives a secure invite link to set their password, then signs in with their email — and gets access to every project in your studio.",
  },
  {
    icon: UserPlus,
    title: "Adding clients",
    body: "Add a client's email when you create or edit a project. Your client registers (or logs in) with that same email to reach their own client dashboard — showing only the project(s) you've shared with them.",
  },
  {
    icon: SlidersHorizontal,
    title: "Control what clients see",
    body: "Open the Settings tab to set your studio-wide defaults, then use \u201cClient Access\u201d on any project to fine-tune exactly what that client can view and edit. Use \u201cPreview as client\u201d to see it from their side.",
  },
];

export default function WelcomeDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none border-[#EBE5E0] bg-white max-w-2xl max-h-[90vh] overflow-y-auto p-0" data-testid="welcome-dialog">
        <div className="bg-[#A68A6B] text-white px-8 py-7">
          <span className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-white/80 mb-3">
            <Sparkles size={14} strokeWidth={1.5} /> Getting started
          </span>
          <DialogHeader className="space-y-2">
            <DialogTitle className="font-serif text-3xl sm:text-4xl text-white" data-testid="welcome-title">
              Welcome to your WorkRoom!
            </DialogTitle>
            <DialogDescription className="text-sm text-white/90 leading-relaxed">
              Before you get started on your admin streamlining bliss, here are a few helpful tips.
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="px-8 py-6 space-y-5">
          {TIPS.map((t, i) => {
            const Icon = t.icon;
            return (
              <div key={i} className="flex gap-4" data-testid={`welcome-tip-${i}`}>
                <div className="shrink-0 w-10 h-10 border border-[#EBE5E0] bg-[#F9F8F6] flex items-center justify-center">
                  <Icon size={18} strokeWidth={1.5} className="text-[#A68A6B]" />
                </div>
                <div>
                  <p className="font-serif text-lg text-[#2B2622] leading-tight">{t.title}</p>
                  <p className="text-sm text-[#5C5651] mt-1 leading-relaxed">{t.body}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="px-8 pb-8">
          <Button data-testid="welcome-dismiss-btn" onClick={() => onOpenChange(false)}
            className="w-full rounded-none bg-[#A68A6B] hover:bg-[#8C7154] text-white uppercase tracking-wider text-xs py-6">
            Let's get started
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
